(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsListFilterFilterStandalone', rmsListFilterFilterStandAlone);

    function rmsListFilterFilterStandAlone() {
        return {
            restrict: 'E',
            scope: {
                options: '=',
                filterForm: '=?',
            },
            controllerAs: 'vm',
            controller: rmsListFilterFilterStandAloneCtrl,
            bindToController: true,
            templateUrl: function(elem, attr) {
                if (attr.templateFullPath) {
                    return attr.templateFullPath;
                }

                if (attr.template) {
                    return 'common/app/components/list-filter/' + attr.template;
                }
                return 'common/app/components/list-filter/list-filter-filter-standalone-default';
            },
            link: function(scope, elem) {
                const vm = scope.vm;
                const showFilterButton = elem.find('.show-advance-filters');
                const advanceSearch = elem.find('.advanced-search');
                vm.onShowButtonClick = onShowButtonClick;


                function onShowButtonClick() {
                    if (showFilterButton.hasClass('active')) {
                        showFilterButton.removeClass('active');
                        advanceSearch.slideUp();
                    } else {
                        showFilterButton.addClass('active');
                        advanceSearch.slideDown();
                    }
                }
            }
        }
    }

    function rmsListFilterFilterStandAloneCtrl($scope, lodash, $interval, ListFilterStateFactory, FormBuilderService) {
        const vm = this;
        var listFilterIdentifier = 'default';
        this.$onInit = function() {
            listFilterIdentifier = lodash.get(vm.options, 'identifier', 'default');

            vm.onSortChange = onSortChange;
            vm.searchTextChanged = searchTextChanged;

            $scope.filterInterval = $interval(function() {
                initListFilterService();
                if (!!$scope.listFilterService) {
                    $interval.cancel($scope.filterInterval);
                    init();
                }
            }, 300);
        }

        function init() {
            $scope.$watch(function () {
                if (!vm.filterForm) return null;
                return FormBuilderService.getModel(vm.filterForm.name);
            }, function () {
                // do refresh grid
                initListFilterService();

                if (lodash.has(vm.filterForm, 'model.search_txt')) {
                    vm.searchText = vm.filterForm.model.search_txt;
                    delete vm.filterForm.model.search_txt;
                    $scope.listFilterService.setSearchText(vm.searchText);
                }

                const filters = generateFilters();
                $scope.listFilterService.getFilterService().setActiveFilter('applied', filters);
                $scope.listFilterService.refreshGrid(true);
            }, true);
        }

        function generateFilters() {
            if (!vm.filterForm) return [];
            const formModel = FormBuilderService.getModel(vm.filterForm.name);
            const formModelNotEmpty = lodash.omitBy(formModel, function(value) {
                if (lodash.isNumber(value)) {
                    return false;
                }
                return lodash.isEmpty(value);
            });
            const modelKeys = lodash.keys(lodash.omit(formModelNotEmpty, ['hid_ref_form']));

            return modelKeys.map(function(key) {
                var modelValue =formModel[key];
                if (!lodash.isArray(modelValue)) {
                    modelValue = [modelValue];
                }
                return {
                    field: key,
                    operator: 'in',
                    value: modelValue,
                };
            });
        }

        function onSortChange() {
            console.log('sort change', vm.sortBy);
            initListFilterService();
            if (vm.sortBy) {
                const sort = vm.sortBy.split('|');
                $scope.listFilterService.getGrid().dataSource.sort({field: sort[0], dir: sort[1]});
            } else {
                $scope.listFilterService.getGrid().dataSource.sort({});
            }
            $scope.listFilterService.refreshGrid(true);
            //$scope.listFilterService.getGrid().dataSource.sort();
        }

        function searchTextChanged() {
            initListFilterService();
            $scope.listFilterService.setSearchText(vm.searchText);
            $scope.listFilterService.refreshGrid(true);
        }

        function initListFilterService() {
            if (!$scope.listFilterService) {
                $scope.listFilterService = ListFilterStateFactory.get(listFilterIdentifier);
            }

        }

    }
})();